import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative w-full overflow-hidden bg-gradient-to-b from-[#FDFAF6] to-[#F0FDF4] pt-16 pb-24 lg:pt-24 lg:pb-32 px-4 sm:px-6 lg:px-8" data-id="element-82">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none" data-id="element-83">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-[#2D8C4E]/5 blur-3xl" data-id="element-84" />
        <div className="absolute top-[40%] -left-[10%] w-[40%] h-[40%] rounded-full bg-[#F59E0B]/5 blur-3xl" data-id="element-85" />
      </div>

      <div className="max-w-7xl mx-auto" data-id="element-86">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-87">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="max-w-2xl" data-id="element-88">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-[#1A1A1A]" data-id="element-89">
              <span className="text-[#2D8C4E]" data-id="element-90">12</span>Metabolismo: El Método
              en 5 Minutos para Despertar tu Cuerpo y Eliminar la Fatiga Crónica
            </h1>

            <p className="text-lg sm:text-xl text-gray-700 mb-10 leading-relaxed font-sans" data-id="element-91">
              Descubre cómo mujeres de 33 a 65 años reactivan su metabolismo en
              solo 12 días, sin dietas extremas ni entrenamientos agotadores.
            </p>

            <button onClick={scrollToOffer} className="w-full sm:w-auto inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white bg-[#2D8C4E] rounded-full hover:bg-[#24753F] transition-all duration-300 shadow-[0_8px_30px_rgb(45,140,78,0.3)] hover:shadow-[0_8px_30px_rgb(45,140,78,0.5)] hover:-translate-y-1" aria-label="Quiero Empezar Ahora" data-id="element-92">
              👉 Quiero Empezar Ahora
            </button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative lg:ml-auto w-full max-w-lg mx-auto lg:max-w-none" data-id="element-93">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/3] lg:aspect-square" data-id="element-94">
              <img src="https://cdn.magicpatterns.com/uploads/99g9PtNDfjoQ7AmPsBvQd7/heylloyd-image-1773959354072.png" alt="Mujer sonriente usando una tablet en su cocina, representando vitalidad y salud" className="absolute inset-0 w-full h-full object-cover" data-id="element-95" />
              <div className="absolute inset-0 border-4 border-white/20 rounded-2xl pointer-events-none" data-id="element-96"></div>
            </div>
            {/* Decorative leaf-like blob */}
            <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-[#F59E0B] rounded-tl-[40px] rounded-br-[40px] rounded-tr-md rounded-bl-md -z-10 opacity-20" data-id="element-97"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}